export const proposalsKeys = {
  all: ['proposals'] as const,
  lists: () => [...proposalsKeys.all, 'list'] as const,
  list: (params: Record<string, any>) =>
    [...proposalsKeys.lists(), params] as const,

  details: () => [...proposalsKeys.all, 'detail'] as const,
  detail: (id: number) => [...proposalsKeys.details(), id] as const,

  campaign: (campaignId: string) =>
    [...proposalsKeys.all, 'campaign', campaignId] as const,

  basket: (basketId: number) =>
    [...proposalsKeys.all, 'basket', basketId] as const,

  committedBasket: (basketId: number) =>
    [...proposalsKeys.all, 'committedBasket', basketId] as const,

  materials: (id: number) =>
    [...proposalsKeys.detail(id), 'materials'] as const,
};
